export const h = {
  stat:{
    zcrs:"Número de registos",
    scrs:"Número de utilizadores de primeira carga",
    scje:"Montante inicial do depósito",
    yhkbs:"Número de transacções bancárias com cartão",
    yhkrj:"Depósito com cartão bancário",
    usdtbs:"Número de transacções USDT",
    usdtrj:"Depósito USDT",
    cjbs:"Número de operações de retirada de ouro",
    cjje:"Montante de retirada",
    tdzrs:"Número total de membros da equipa"
  },
	login:{
			login:"Conecte-se",
			pleaseusername:"por favor insira o nome de usuário",
			pleasepassword:"Por favor insira a senha",
			checkname:"Por favor insira o nome de usuário correto",
			checkpass:"A senha não pode ter menos de 3 caracteres",
		},
	navbar:{
		home:"primeira página",
		mycenter:"Centro Pessoal",
		outlogin:"desistir",
		close:"fecho",
		editLanguage:"idioma de edição",
	},
	vip:{
    ywy:"Vendedor",
		nickname:"Apelido",
		pleasenickname:"Por favor insira um apelido",
		username:"nome de usuário",
		pleaseusername:"por favor insira o nome de usuário",
		arealogin:"Área de login",
		pleasearealogin:"Por favor insira sua área de login",
		nationality:"País de cidadania",
		pleasenationality:"Por favor selecione a nacionalidade",
		depositstatus:"Status do depósito",
		pleasedepositstatus:"Selecione o status do depósito",
		createtime:"hora de criação",
		logintime:"Horário de login",
		startime:"Hora de início",
		endtime:"Fim do tempo",
		no:"número de série",
		shangji:"Recomendação direta aos superiores",
		keyongmoney:"Saldo disponível",
		baozhengjing:"margem",
		fudongyingkui:"Lucros e perdas flutuantes",
		zicantotal:"Ativos totais",
		yaoqingma:"Código de Convite",
		zongrujing:"depósito total",
		zongchujing:"Retiradas totais",
		loginIp:"ip de login",
		zuihoulogin:"última hora de login",
		shoucirujingmoney:"Valor do primeiro depósito",
		shoucirujingtime:"Hora do primeiro depósito",
		kaitongtime:"Tempo de abertura",
		keyong:"Disponível",
		daoshi:"tutor",
		dongjie:"congelar",
		chujingstate:"Status de retirada",
		xiajichujingstate:"Status de retirada de nível inferior",
		caozuo:"operar",
		chakan:"Verificar",
		heji:"total",
		moneytotal:"balanço total",
		paixu:"organizar",
		daochu:"Exportar",
		huiyuanguanli:"Gestão de membros",
		yonghu:"do utilizador",
		search:"Consultar pesquisa",
		reset:"reiniciar",
		delete:"excluir",
		kickout:"expulsar",
		notlogin:"Não logado",
		editLanguage:"idioma de edição",
		yourujing:"Há um depósito",
		wurujing:"Sem depósito",
    todayreg: "Volume de registros do dia de hoje: ",
    newvipnum: "O número de novos membros VIP que ingressaram: ",
    juese: "papel",
    xiugaimima: "alterar senha",
    jiumima: "senha antiga",
    shurujiumima: "por favor, digite a senha antiga",
    xinmima: "nova senha",
    shuruxinmima: "por favor, digite a nova"
	},
	info:{
		home:"Pagina inicial",
		user:"ID do usuário",
		nickname:"Apelido",
		account:"conta",
		identity:"número de identidade",
		phone:"número de telefone",
		nationality:"País de cidadania",
		Balance:"Gestão de saldo",
		real:"conta real",
		zhongmongy:"balanço total",
		keyongmoney:"Saldo disponível",
		jiaoyidongjie:"Transação congelada",
		shishilirun:"lucro em tempo real",
		shishikeyong:"Disponível em tempo real",
		xunizhanghu:"conta virtual",
		churujinguanli:"Gestão de depósitos e retiradas",
		chakanzijinjilu:"Ver histórico de fundos",
		rujinjilu:"Registro de depósito",
		rujinjine:"Valor do depósito",
		jiaoyibishu:"Número de transações",
		chujinjilu:"Registros de retirada",
		chujinjine:"Quantidade retirada",
		jiaoyiguanli:"Gerenciamento de transações",
		lishijilu:"registro histórico",
		chakanlishi:"Ver informações históricas de transações",
		jiaoyishoushu:"Negociação de lotes",
		jiaoyiyingkui:"Lucros e perdas comerciais",
		dangqianchicang:"Posição atual",
		chakandangqianchicang:"Ver informações de posição atual",
		dangqianguadan:"Ordem pendente atual",
		chakanguadanliebiao:"Ver lista de pedidos pendentes",
		guadanbishu:"Número de pedidos pendentes",
		yongjinguanli:"Gestão da comissão",
		duanwei:"classificação",
		wu:"nenhum",
		zhishushangji:"Superior imediato",
		shangjidaili:"Agente superior",
		xiajituandui:"Equipe subordinada",
		shurudailiname:"Por favor insira o nome do agente",
		chakan:"Verificar",
		fanyongjie:"Valor do desconto",
		fanyongbishu:"Número de descontos",
		chakanyongjinjilu:"Ver registros de descontos",
		chakanyonghuinfo:"Ver detalhes do usuário",
		chakanwenjuan:"Ver questionário",
		resetpassword:"redefinir senha",
		sendmsg:"enviar mensagem",
		update:"Rever",
		unbound:"Não vinculado",
		weishiming:"N",
		yishiming:"Y",
		shiming:"realname",
		gendan:"Gestão de documentação",
		gensui:"seguir",
		chakangendan:"Ver registros de pedidos",
		dingdanhao:"número do pedido",
		shoudongpay:"Recarga manual",
		chakanyongjingjilu:"Ver histórico de comissões",
		xiugaiyonghuxinxi:"Modificar informações do usuário",
		queding:"Claro",
		quxiao:"Cancelar",
		email:"Correspondência",
		selguoji:"Por favor selecione a nacionalidade",
		sendusermsg:"Enviar mensagem ao usuário",
		title:"título",
		shurutitle:"Por favor insira o título da mensagem",
		content:"contente",
		shurucontent:"Por favor insira o conteúdo da mensagem",
		zhenshi:"realidade",
		xuni:"virtual",
		fangxiang:"direção",
		zhanghu:"Conta",
		add:"Aumentar",
		less:"deduzir",
		type:"tipo",
		guanliyuanpay:"Recarga de administrador",
		pay:"completar",
		money:"Quantia",
		updategdmsg:"Modificar informações do pedido",
		xinhaoyuan:"fonte de sinal",
		yes:"sim",
		no:"não",
		updateyongjingmsg:"Modificar informações de comissão",
		qingxuanzejuese:"Selecione a função da conta",
		zuoduo:"Vá longe",
		zuokong:"curto",
		gensuinicheng:"siga o apelido",
		kaicangjia:"preço de abertura",
		pingcangjia:"Preço final",
		shousu:"Tamanho do lote",
		pingcangdate:"Data de abertura da posição",
		kaicangdate:"Data de encerramento",
		chakangensuiinfo:"Ver detalhes a seguir",
		gensuiuserno:"Siga o número do usuário",
		gensuiyonghuname:"Seguir o apelido do usuário",
		gensuifangshji:"siga o método",
		number:"quantidade",
		danwei:"unidade",
		zhengxiang:"avançar",
		fanxaing:"reverter",
		beishu:"múltiplo",
		shousu:"Tamanho do lote",
		gensuizhuangtai:"seguir status",
		genjinzhong:"A aplicação está seguindo",
		gensuiok:"Concorde em ser seguido",
		gensuino:"Recusou-se a ser seguido",
		chexiao:"Cancelar",
		gensuidate:"seguir o tempo",
		chakanlishijiaoyi:"Ver informações históricas de transações",
		chakanguadanlist:"Ver lista de pedidos pendentes",
		heyue:"contrato",
		daili:"atuando",
		huiyuanname:"Nome do membro",
		xianjia:"limite de preço",
		zhisun:"parar a perda de",
		guadanjia:"preço da ordem pendente",
		zhiyingzhisun:"Obtenha lucro e pare a perda",
		zhiyingjia:"Preço de lucro",
		zhiyinghuichejia:"Preço de retração Take Profit",
		zhisunjia:"Preço de parada de perda",
		zhisunhuichejia:"Preço de retração de stop loss",
		weiset:"não configurado",
		zt:"estado",
		chakanchicangmsg:"Ver informações de posição atual",
		shouyiId:"ID do beneficiário",
		xiajiid:"ID do usuário subordinado",
		xiajiuser:"Nome de usuário subordinado",
		fanyongmonney:"Valor do desconto",
		tuihuibaozhengjing:"Depósito de devolução",
		shouxufei:"taxa de manuseio",
		shouyi:"renda",
		lixi:"Interesse",
		zengmoney:"bônus",
		zhuijiabaozhengjing:"chamada de margem",
		fanyong:"Desconto",
		rujing:"Depósito",
		chujing:"Retirar fundos",
		chujingshibai:"Reembolso se a análise da retirada falhar",
		guanliyuanless:"Dedução administrativa",
		pingzhong:"Variedade",
		shengqingzhong:"Aplicando",
		wancheng:"Terminar",
		chongzhimima:"Redefinição de senha bem-sucedida",
		copy:"cópia de",
		zhanghaomima:"Senha da conta",
		fenye:"Artigo/Página",
    tixianmima:"Senha de retirada",
		gong:"comum",
		tiao:"faixa",
		ye:"Página",
		goto:"Vá para",
		outtitle:"Você foi desconectado. Você pode cancelar e permanecer nesta página ou fazer login novamente.",
		outok:"OK para sair",
		chongxingdenglu:"registrar-se novamente",
		cancel:"Cancelar",
		pingtai:"plataforma",
		nodata:"Sem dados",
    shangjiID: "ID Superior",
    shangjiaccount: "Conta Superior",
    shangjiname: "Apelido Superior",
    shangjinickname: "Nome Superior",
    zhongyingkui: "Lucro e Prejuízo Total",
    fuying: "Lucro Flutuante",
    yue: "Saldo",
    sheng: "Ordem Crescente",
    jiang: "Ordem Decrescente"
	},
	history:{
			guadan:"Lucros e perdas",
			shijia:"pedido pendente",
			gendan:"preço de mercado",
			dangqianjia:"Seguir ordens",
			geyelixi:"preço atual",
			weituodate:"juros noturnos",
			pingcangfangshi:"Tempo de comissão",
			dingdanyongjing:"Método de fechamento",
			shoudongpingcang:"Comissão de pedido",
			qiangzhipingcang:"Fechamento manual",
			gendanpingcang:"Liquidação forçada",
			baocang:"Liquidação",
			yuguqiangpingjia:"Siga ordens para fechar uma posição",
			kaicangdiqu:"Preço estimado de paridade forçada",
			ispingcang:"Área de abertura",
			tips:"Você tem certeza sobre a liquidação forçada?",
			pincangsucc:"dica",
			queding:"Posição fechada com sucesso",
			cancel:"Claro"
		},

	Langswitch: {
	  "en":"Inglês",
	  "id":"indonésio",
	  "th":"Língua Tailandesa",
	  "vi":"vietnamita",
	  "zh":"chinês",
	  "fa":"Francês",
	  "han":"coreano",
	  "tu":"turco",
	  "pu":"Português",
	  "xi":"espanhol",
	  "jp":"japonês",
	  "ar":"árabe",
	},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/pu.js